import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { useCapacitor } from '../../../hooks/useCapacitor';
import { useQuery } from '../../../hooks/useQuery';
import { Footer } from '../../components/Footer/Footer';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { LoginModal } from '../../components/LoginModal/LoginModal';
import { Topbar } from '../../components/Topbar/Topbar';
import { getPublicResourcesBaseUrl, verifyHashedQueryParams } from '../../utils/utils';
import './Home.scss';

const tmpBg = getPublicResourcesBaseUrl() + 'rebrand_common_assets/LP_Background.webp';

const HomeComponent = () => {
  const { isLoggedIn, requestImpersonationToken, loginWithToken } = useFirebase();
  const { isNative } = useCapacitor();
  const history = useHistory();
  const { logout, uid, sender, token, redirectTo } = useQuery();

  useEffect(() => {
    if (isLoggedIn && !logout) history.replace('/browse');
  }, [isLoggedIn]);

  if (['localhost:3002', 'impersonate.tootor.it'].includes(window.location.host)) {
    sessionStorage.clear();
    if (!uid || !sender || !token) window.location.href = 'https://app.tootor.it';
    verifyHashedQueryParams({ uid, sender, token }).then((valid) => {
      if (!valid) window.location.href = 'https://app.tootor.it';
      else requestImpersonationToken(uid, sender).then(loginWithToken).catch(console.error);
    });
    return <FullscreenLoader />;
  }

  if (logout) return <FullscreenLoader />;

  if (isNative && !isLoggedIn && !logout) return <LoginModal isModalOpen={true} showCancel={false} />;

  return (
    <div className={'lp-page-wrapper'} style={{ backgroundImage: `url(${tmpBg})` }}>
      <Topbar showLoginButtonIfNeeded={false} />

      <LoginModal isModalOpen={true} asFullPage={true} showCancel={false} showSignup={true} redirectTo={redirectTo} />

      <div className={'lp-footer'}>
        <Footer />
      </div>
    </div>
  );
};

export default HomeComponent;
